import useModelStoreModule from '@/views/models/common/useModelStoreModule'
import productCategoryModel from './productCategoryModel'

const {
  fetchList,
  fetchAll,
  fetchOne,
  create,
  update,
  deleteMany,
  sorting,
} = useModelStoreModule(productCategoryModel)

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchList,
    fetchAll,
    fetchOne,
    create,
    update,
    deleteMany,
    sorting,
  },
}
